<div
  class="item-modal-backdrop"
  (click)="onClose()"
  aria-hidden="true"
  >
  @if (selectedItem(); as modalItem) {
    <div
      class="item-modal"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="modalItem.id | translate"
      (click)="$event.stopPropagation()"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
      (keydown)="handleKeydown($event)"
      >
      <button type="button" class="modal-close" (click)="onClose()" aria-label="Close modal">×</button>
      <button type="button" class="d-none d-sm-block modal-nav modal-prev" (click)="onPrevious()" aria-label="Previous dish">‹</button>
      <button type="button" class="d-none d-sm-block modal-nav modal-next" (click)="onNext()" aria-label="Next dish">›</button>
      <div class="modal-image-shell">
        <app-progressive-image
          class="modal-progressive-image"
          [src]="imagesPath + modalItem.id + '.jpg'"
          [defaultSrc]="imagesPath + defaultImagePath"
          [alt]="modalItem.id | translate"
        ></app-progressive-image>
      </div>
      <div class="modal-content">
        <h3 class="modal-title">{{ modalItem.id | translate }}</h3>
        <div class="modal-price">{{ modalItem.price | currency: 'EUR' }}</div>
        <p class="modal-description">{{ (modalItem.id + '.desc') | optTranslate }}</p>
      </div>
      <div class="modal-hint d-md-none">Swipe for the next dish</div>
    </div>
  }
</div>